import { HStack } from '@fhs-legacy/universal-components';

const CartItemPrice = HStack.withConfig({
  marginTop: '$6',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});

export default CartItemPrice;
